import { customElement, property } from 'lit/decorators.js';
import { css, html, nothing } from 'lit';
import { BaseComponent } from '../../base-component/base-component';
import { ProductCardData } from '../product-card-display';
import '../product-card-display/product-card-image.display';
import '../product-card-display/product-card-metadata.display';
import { booleanConverter } from '../../../common/converters';
import { getProductUrl, goToProductPage } from '../utils/product-card.util';
import { connect } from 'pwa-helpers';
import store from '../../../store/store';
import { CtaTypeLabel } from '../product.interface';
import { emitProductAnalyticsEvent } from '../utils/product-card.analytics.util';
import { HE_LOWER } from '../../../common/utils/util';

@customElement('mhecomm-he-product-card-display')
export class HeProductCardDisplay extends connect(store)(BaseComponent) {
  @property({ type: Object })
  product?: ProductCardData;

  @property({ converter: booleanConverter })
  showBusinessUnitLabel = false;

  @property({ converter: booleanConverter })
  showBusinessLabelType = true;

  @property({ converter: booleanConverter })
  showCopyright = false;

  @property({ converter: booleanConverter })
  showEdition = false;

  @property({ converter: booleanConverter })
  showAuthors = false;

  @property({ converter: booleanConverter })
  showISBN = false;

  @property({ type: String })
  businessLabelText = 'Higher Ed';

  @property({ type: String })
  businessLabelType = 'Product';

  @property({ type: String })
  cta = CtaTypeLabel.NO_CTA;

  @property()
  orientation = 'vertical';

  @property({ type: String })
  headingLevel = "h3";

  static styles = [
    css`
      .uxt-mhcorp {
        height: 100%;
      }
    `,
  ];

  renderComp() {
    return this.product
      ? html` <div
          class="product-card ${this
            .orientation} align-items-center rounded text-left shadow border-0 h-100 d-flex position-relative whole-card-clickable focus-within mx-auto"
        >
          <mhecomm-product-card-image-display
            productTitle="${this.product?.title}"
            productImageUrl="${this.product?.image}"
          >
          </mhecomm-product-card-image-display>
          <div class="product-card-contents p-3 lh-base d-flex flex-column h-100">
            <mhecomm-product-card-metadata-display
              .product="${this.product}"
              ?wholecardclickable=${true}
              .titleTabbable=${this.cta === CtaTypeLabel.NO_CTA}
              businessLabelText="${this.businessLabelText}"
              businessLabelType="${this.businessLabelType}"
              ?showBusinessUnitLabel="${this.showBusinessUnitLabel}"
              ?showBusinessLabelType="${this.showBusinessLabelType}"
              ?showEdition="${this.showEdition}"
              ?showAuthors="${this.showAuthors}"
              ?showCopyright="${this.showCopyright}"
              titleHref="${getProductUrl(this.product)}"
              headingLevel="${this.headingLevel}"
              .titleClickListener=${(e: Event) => {
                e.preventDefault();
                const target = e.currentTarget as HTMLAnchorElement;
                emitProductAnalyticsEvent(this, this.product!, HE_LOWER, 'mhecomm-he-product-cards');
                window.location.href = target.href;
              }}
            >
            </mhecomm-product-card-metadata-display>
            ${this.cta !== CtaTypeLabel.NO_CTA ? this.generateProductCardCta(this.product) : nothing}
          </div>
        </div>`
      : nothing;
  }

  generateProductCardCta(product) {
    return html`<div class="product-card-cta-container pt-3 w-100">
      <button
        class="product-card-view-button btn btn-primary w-100 stretched-link"
        aria-label="View Product ${product.title}"
        @click="${() => {
          emitProductAnalyticsEvent(this, product, HE_LOWER, 'mhecomm-he-product-cards');
          goToProductPage(product);
        }}"
      >
        View Product
      </button>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-he-product-card-display': HeProductCardDisplay;
  }
}
